<template>
  <div>

    <ScrollToTop></ScrollToTop>

    <header id="header">
      <router-link class="logo" :to="{ name: 'Start'}">
        <img src="/projects/hetfruit/templates/customerportal/images/logo.png" height="60">
      </router-link>
      <h3>Bedrijven bestellingen</h3>
      <router-link v-if="route_filter" :to="`/PrintRoute/${route_filter}/${week_filter}`" target="_blank" rel="noopener">
        Print Route
      </router-link>
    </header>

    <div class="content-container">

      <flash-message></flash-message>

      <div class="list-filters">

        <input type="search" v-model="text_search" placeholder="Zoeken..." class="list-filter list-search"
               @blur="filterChange">

        <select name="city_filter" class="list-filter" v-model="city_filter" @change="filterChange">
          <option value="">Filter op dorp</option>
          <option v-for="city in cities" :key="city" :value="city">
            {{ city }}
          </option>
        </select>

        <select name="route_filter" class="list-filter" v-model="route_filter" @change="routeChange">
          <option value="">Filter op route</option>
          <option v-for="route_nr in routes" :key="route_nr" :value="route_nr">
            {{ route_nr }}
          </option>
        </select>
        <select name="week_filter" class="list-filter" v-model="week_filter" @change="filterChange">
          <option value="">Filter op week</option>
          <option v-for="week in next4Weeks" :key="week.value" :value="week.value">
            {{ week.label }}
          </option>
        </select>
        <select name="week_filter" class="list-filter" v-model="delivery_day_filter" @change="filterChange">
          <option value="">Filter op leverdag</option>
          <option v-for="day in deliveryDays" :key="day.id" :value="day.id">
            {{ day.name }}
          </option>
        </select>
      </div>

      <div class="list-filters">
        Toon bestellingen met status:
        <label class="status ordered">
          <input type="checkbox" v-model="or_status_ordered" @change="filterChange">besteld
        </label>
        <label class="status processed">
          <input type="checkbox" v-model="or_status_processed" @change="filterChange">verwerkt
        </label>
        <label class="status cancelled">
          <input type="checkbox" v-model="or_status_cancelled" @change="filterChange">geannuleerd
        </label>
        <label class="status new">
          <input type="checkbox" v-model="or_status_new" @change="filterChange">nieuw
        </label>
        <label class="status inconto">
          <input type="checkbox" v-model="or_type_inconto" @change="filterChange">inconto
        </label>
      </div>

      <div class="list-table">
        <div class="list-row header">
          <div class="column-company">Bedrijf:</div>
          <div class="column-date">Datum:</div>
          <div class="column-update">Laatst aangepast:</div>
          <div class="column-status">Status:</div>
          <div class="column-actions"></div>
        </div>

        <div class="list-row" v-for="company_order in company_orders_filtered" :key="company_order.id"
             :class="order_class(company_order)">
          <div class="data-row column-company">
            <b>{{ company_order.company_name }}</b>
            <br>
            <span class="address">{{ company_order.company_address }}</span>
          </div>
          <div class="data-row column-date"> {{ company_order.delivery_date }}</div>
          <div class="data-row column-update"> {{ company_order.last_update }}</div>
          <div class="data-row column-status">{{ company_order.status_name }}</div>
          <div class="data-row column-actions">
            <a class="btn btn-with-icon" @click.prevent="editOrder(company_order.id)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.3"
                      d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                      fill="#ffffff"></path>
                <path
                    d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                    fill="#fafafa"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import ErrorHelper from "../helpers/ErrorHelper";
import HfHelper from "../helpers/HfHelper";
import FlashMessage from "../components/FlashMessage";
import {SimpleStore} from "../simplestore";
import ScrollToTop from "../components/ScrollToTop.vue";


export default {
  name: "CompanyOrders",
  components: {ScrollToTop, FlashMessage},
  data() {
    return {
      company_orders: [],
      city_filter: SimpleStore.company_orders_filters.city ?? '',
      route_filter: SimpleStore.company_orders_filters.route ?? '',
      week_filter: SimpleStore.company_orders_filters.week ?? '',
      delivery_day_filter: SimpleStore.company_orders_filters.delivery_day ?? '',
      order_by: SimpleStore.company_orders_filters.order_by ?? '',
      or_status_ordered:SimpleStore.company_orders_filters.or_status_ordered ?? true,
      or_status_cancelled:SimpleStore.company_orders_filters.or_status_cancelled ?? false,
      or_status_new:SimpleStore.company_orders_filters.or_status_new ?? false,
      or_status_processed:SimpleStore.company_orders_filters.or_status_processed ?? true,
      or_type_inconto:SimpleStore.company_orders_filters.or_type_inconto ?? false,
      text_search: SimpleStore.company_orders_filters.search ?? '',
      pages_being_edited: [],
      fetch_edit_times: 0,
      fetch_list_times: 0,
      fetch_interval: false,
      fetch_interval_orders: false,
      deliveryDays: HfHelper.deliveryDays(),
    };
  },
  mounted() {
    let vue_instance = this;

    this.getCompanyOrders().then(() => {
      vue_instance.getPagesBeingEdited();
      // haal elke 2 seconden de pagina's op die bewerkt worden
      this.fetch_interval = setInterval(() => vue_instance.getPagesBeingEdited(), 2000);
    });

    this.week_filter = SimpleStore.company_orders_filters.week ?? this.next4Weeks[1].value;
    this.delivery_day_filter = SimpleStore.company_orders_filters.delivery_day ?? "";

    this.fetch_interval_orders = setInterval(() => vue_instance.getCompanyOrders(false), 5000);

    if (SimpleStore.company_orders_filters.length == 0) {
      SimpleStore.company_orders_filters.city = '';
      SimpleStore.company_orders_filters.route = '';
      SimpleStore.company_orders_filters.order_by = '';
      SimpleStore.company_orders_filters.or_status_ordered = true;
      SimpleStore.company_orders_filters.or_status_cancelled = false;
      SimpleStore.company_orders_filters.or_status_new = false;
      SimpleStore.company_orders_filters.or_status_processed = true;
      SimpleStore.company_orders_filters.or_type_inconto = false;
      SimpleStore.company_orders_filters.search = '';
    }

  },

  unmounted() {
    // belangrijk: interval uitzetten als we van pagina wisselen;
    clearInterval(this.fetch_interval)
    clearInterval(this.fetch_interval_orders)
  },

  computed: {
    cities() {
      if (!this.company_orders) return [];
      let company_orders = this.company_orders;
      // get cities from array
      company_orders = company_orders.map(daycare_order => daycare_order.city);
      // filter out duplicates
      company_orders = company_orders.filter((value, index, array) => array.indexOf(value) === index);
      return company_orders;
    },
    routes() {
      if (!this.company_orders) return [];
      let company_orders = this.company_orders;
      // get cities from array
      company_orders = company_orders.map(company_order => company_order.route_name ?? '');
      // filter out duplicates
      company_orders = company_orders.filter((value, index, array) => array.indexOf(value) === index);
      // filter out empty route names
      company_orders = company_orders.filter((value) => value !== '');
      // sort by name
      // company_orders.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))  // company_orders.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

      // soort op naam, maar maandag vooraan
      company_orders.sort((a, b) => {
        if (a.toLowerCase().includes('maandag') && !b.toLowerCase().includes('maandag')) return -1;
        if (!a.toLowerCase().includes('maandag') && b.toLowerCase().includes('maandag')) return 1;
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });

      return company_orders;
    },
    company_orders_filtered() {
      if (!this.company_orders) return [];

      let company_orders = this.company_orders;

      if (this.city_filter) {
        company_orders = company_orders.filter((value) => value.city === this.city_filter);
      }

      // Status-Filter over filter
      const statusFilter = [];
      if (this.or_status_ordered) statusFilter.push('ordered');
      if (this.or_status_cancelled) statusFilter.push('cancelled');
      if (this.or_status_new) statusFilter.push('new');
      if (this.or_status_processed) statusFilter.push('processed');
      if (statusFilter.length > 0) {
        company_orders = company_orders.filter((value) => statusFilter.includes(value.status_key));
      }

      if(this.or_type_inconto){
        company_orders = company_orders.filter((value) => value.subscription_type === 'inconto');
      }

      if (this.route_filter) {
        company_orders = company_orders.filter((value) => value.route_name === this.route_filter);
      }
      if (this.text_search) {
        company_orders = company_orders.filter((value) => value.company_name.toLowerCase().includes(this.text_search.toLowerCase()));
      }

      if (this.week_filter) {
        company_orders = company_orders.filter((value) => value.week_nr == this.week_filter);
      }

      if (this.delivery_day_filter) {
        company_orders = company_orders.filter((value) => value.delivery_day == this.delivery_day_filter);
      }

      if (this.order_by == 'route') {
        company_orders.sort((a, b) => parseInt(a.route_sort) - parseInt(b.route_sort))
        // Definieer de volgorde van de statussen
        const status_volgorde = {
          'ordered': 0,
          'processed': 1,
          'cancelled': 2,
          'merged': 3,
        };
        company_orders.sort((a, b) => status_volgorde[a.status_key] - status_volgorde[b.status_key])
      }

      return company_orders;
    },
    next4Weeks() {
      const weeks = [];
      const today = new Date();
      for (let i = -1; i < 4; i++) {
        const firstDayOfWeek = new Date(today);
        firstDayOfWeek.setDate(today.getDate() + i * 7 - today.getDay() + 1);
        const weekNr = this.getWeekNumber(firstDayOfWeek);
        weeks.push({
          value: weekNr,
          label: `Week ${weekNr} - ${firstDayOfWeek.getDate()} tot ${new Date(firstDayOfWeek.getFullYear(), firstDayOfWeek.getMonth(), firstDayOfWeek.getDate() + 6).getDate()} ${firstDayOfWeek.toLocaleString('default', {month: 'long'})}`,
        })
      }
      return weeks;
    }
  },
  methods: {
    getWeekNumber(date) {
      const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
      const dayNum = d.getUTCDay() || 7;
      d.setUTCDate(d.getUTCDate() + 4 - dayNum);
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
      return Math.ceil((((d - yearStart) / 86400000) + 1)/7);
    },
    getPagesBeingEdited() {
      // we halen de pagina's die bewerkt worden elke x seconden op
      this.fetch_edit_times++;
      // haal ze niet vaker dan 300x op, daarna is de gebruiker waarschijnlijk idle
      if (this.fetch_edit_times > 300) {
        return false;
      }

      fetch('?action=getPagesBeingEdited&page=company_order', {
        method: "GET",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",   // expected data sent back
        },
      }).then(res => res.json()).then((response) => {

        if (ErrorHelper.handleError(this, response)) return;

        this.pages_being_edited = response.data;
      }).catch((error) => {
        this.errors = [];
        this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
      });
    },
    getCompanyOrders(jump_to_scroll_position = true) {
      return new Promise(resolve => {
        // we halen de pagina's die bewerkt worden elke x seconden op
        this.fetch_edit_times++;
        // haal ze niet vaker dan 150x op, daarna is de gebruiker waarschijnlijk idle
        if (this.fetch_edit_times > 150) {
          return false;
        }

        fetch('?action=getCompanyOrders', {
          method: "GET",
          headers: {
            'Content-type': 'application/json',
            "Accept": "application/json",   // expected data sent back
          },
        }).then(res => res.json()).then((response) => {

          if (ErrorHelper.handleError(this, response)) return;

          this.company_orders = response.data;

          // we willen dit alleen de 1ste keer doen, maar niet als de lijst gerefresht wordt
          if (jump_to_scroll_position) {
            this.$nextTick(() => {
              if (localStorage.getItem('company-list-scroll-pos')) {
                window.scroll(0, parseInt(localStorage.getItem('company-list-scroll-pos')));
              }
            });
          }

          resolve();
        }).catch((error) => {
          this.errors = [];
          this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
        });
      });
    },

    filterChange() {
      SimpleStore.company_orders_filters.city = this.city_filter;
      SimpleStore.company_orders_filters.route = this.route_filter;
      SimpleStore.company_orders_filters.week = this.week_filter;
      SimpleStore.company_orders_filters.delivery_day = this.delivery_day_filter;
      SimpleStore.company_orders_filters.search = this.text_search;
      SimpleStore.company_orders_filters.or_status_ordered = this.or_status_ordered;
      SimpleStore.company_orders_filters.or_status_cancelled = this.or_status_cancelled;
      SimpleStore.company_orders_filters.or_status_new = this.or_status_new;
      SimpleStore.company_orders_filters.or_status_processed = this.or_status_processed;
      SimpleStore.company_orders_filters.or_type_inconto = this.or_type_inconto;
    },

    routeChange() {
      SimpleStore.company_orders_filters.city = this.city_filter;
      SimpleStore.company_orders_filters.status = this.status_filter;
      SimpleStore.company_orders_filters.route = this.route_filter;
      SimpleStore.company_orders_filters.week = this.week_filter;
      SimpleStore.company_orders_filters.delivery_day = this.delivery_day_filter;
      SimpleStore.company_orders_filters.search = this.text_search;
      // altijd sorteren op route als we filteren op route
      this.order_by = 'route';
      SimpleStore.company_orders_filters.order_by = this.order_by;
    },

    editOrder(company_order_id) {
      // save the scroll position, this way we can return to it later
      localStorage.setItem('company-list-scroll-pos', Math.round(window.scrollY));
      this.$router.push({name: 'CompanyOrder', params: {orderid: company_order_id}});
    },

    order_class(company_order) {
      return {
        [company_order.status_key]: true,
        'is_being_edited': this.pages_being_edited.includes(company_order.id)
      }
    }

  },
}

</script>

<style scoped>

.list-row.processed, label.processed {
  background-color: rgb(137, 195, 61);
}

.list-row.is_being_edited {
  background-color: hsl(36, 100%, 67%);
}

.list-row.cancelled, label.cancelled  {
  background-color: hsl(13, 87%, 65%);
}

.list-row.new, label.new{
  background-color: rgb(237, 197, 0,0.2);
}
.list-row .column-customernr {
  width: 7%;
}

.list-row .column-company {
  width: 50%;
}

.list-row .column-company .address {
  font-size: 0.9rem;
  color: hsl(0, 0%, 40%);
}

.list-row .column-date {
  width: 12%;
}

.list-row .column-status {
  width: 11%;
  overflow: hidden;
}

.data-row.column-status {
  font-size: 0.9rem;
  color: hsl(0, 0%, 40%);
}

.list-row .column-update {
  width: 15%;
  font-size: 0.9rem;
}

.data-row.column-update {
  color: hsl(0, 0%, 40%);
}

.list-row .column-actions {
  width: 60px;
}

label.status{
  border-radius:  0.5em;
  padding:  0.4em;
  cursor: pointer;
  border: 1px solid black;
}
label.status input{
  margin-right: 0.5em;
  border-radius: 0.5em;
}

.list-row.header{
  background-color: #EEE;
  margin-top: 2em;
}
</style>
